function holdingsListController($scope, $location, Holding) {
  this.createPath = 'holdings/create';
  this.holdingsFilter = { holdingListed: false };

  this.showPath = (id) => `holdings/${id}`;

  const loadHoldings = () => {
    if ($location.search().orderBy) { this.orderBy = $location.search().orderBy; }
    if ($location.search().reverse) { this.reverse = $location.search().reverse; }
    this.page = $location.search().page ? $location.search().page : 1;
    this.search = $location.search().search ? $location.search().search : '';

    this.holdings = Holding.get({
      page: this.page,
      orderBy: this.orderBy,
      reverse: this.reverse,
      search: this.search,
    });
  };

  $scope.$on('$routeUpdate', () => loadHoldings());
  $scope.$watch('ctrl.imports', () => loadHoldings());

  loadHoldings();
  return this;
}

module.exports = ['$scope', '$location', 'Holding', holdingsListController];
